const apiEndPoints = {
  // GET
  GET_EMPLOYER_VALIDATION_PAY_STUB_INFO:
    'v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationDataPaystub',
  GET_EMPLOYER_VALIDATION_W2_INFO:
    'v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationDataW2',
  GET_DOCUMENT: '/v1/DocumentExtraction/Document',
  GET_UNDERWRITER_VERIFICATION_STATUS:
    '/v1/UnderwriterVerified/GetUnderwriterVerified',
  GET_ASSETS_INFORMATION_FOR_ASSET_SUMMARY:
    '/v1/AssetsInformation/GetAssetsInformationForAssetSummary',

  GET_VALIDATE_DOCUMENT_QUESTION_ANSWERS_DATA_ASYNC:
    '/v1/EmploymentIncomeValidation/GetValidateSmartQuestionAnswers',
  SAVE_VALIDATE_DOCUMENT_QUESTION_ANSWERS_DATA_ASYNC:
    '/v1/EmploymentIncomeValidation/UpdateEmploymentSmartQuestionAnswers',

  POST_SAVE_EMPLOYER_VALIDATION_DOCUMENTS:
    '/v1/EmploymentIncomeValidation/UpdateEmploymentAndQuestionAnswers',

  incomeCalculator: {
    BASE_URL: '/v1/IncomeCalculator',
    GET_ASSOC_INCOME_CALCS: '/v1/incomeCalculator/GetCalculations',
    CALCULATE: '/v1/IncomeCalculator/RunCalculations',
    SAVE_EMPLOYMENT_INCOME: '/v1/IncomeCalculator/SaveEmploymentIncomeToLoan',
    GET_INCOME_SUMMARY_DATA: '/v1/IncomeSummary/Get',
    POST_SAVE_INCOME_DOCUMENT_SELECTION: '/v1/IncomeSummary/Save',
    GET_ASSOC_INCOME_DOCS:
      '/v1/DocumentAssociation/GetAssociatedDocumentsByIncome',
    SAVE_EMPLOYMENT_ANSWER: '/v1/EmploymentIncome/SaveEmploymentAnswer',
    GET_CAN_RUN_LEASE_AGREEMENT_CALCULATOR:
      '/v1/IncomeCalculator/CanRunLeaseAgreementCalculator',
    GET_SELECTED_CALCULATOR_DATA:
      '/v1/IncomeCalculator/GetDataForSelectedCalculator',
    GET_EMPLOYMENT_INCOME_VALIDATION_DATA:
      'v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationData',
    GET_EMPLOYMENT_INCOME_VALIDATION_DATA_WITH_FIELD_RESOLUTION:
      'v1/EmploymentIncomeValidation/GetEmploymentIncomeValidationDataWithFieldResolution',
    GET_CALCULATION_HISTORY: '/v1/IncomeCalculator/GetCalculationsHistory',
    SAVE_RENTAL_INCOME_TO_LOAN: '/v1/IncomeCalculator/SaveRentalIncomeToLoan',

    GET_SMART_DATA_FOR_SELECTED_CALCULATOR:
      '/v1/IncomeCalculator/GetSmartDataForSelectedCalculator',
    SAVE_SMART_DATA_FOR_SELECTED_CALCULATOR:
      '/v1/IncomeCalculator/RunSmartCalculations',
  },

  incomeReconciliation: {
    GET_INCOME_RECONCILIATION_DATA:
      '/v1/IncomeReconciliation/GetIncomeReconciliationData',
    SAVE_INCOME_RECONCILIATION_DATA:
      '/v1/IncomeReconciliation/SaveIncomeReconciliationData',
    CALCULATE_DEBT_TO_INCOME: '/v1/IncomeReconciliation/CalculateDebtToIncome',
  },

  employmentIncome: {
    GET_EMPLOYMENT_QUESTIONS: '/v1/EmploymentIncome/GetEmploymentQuestions',
    GET_ANSWERED_QUESTIONS: '/v1/EmploymentIncome/GetAnsweredQuestions',
    REMOVE_INCOME_AND_EMPLOYMENT_INFO:
      'v1/EmploymentIncome/RemoveIncomeAndEmploymentInfo',
  },

  underwritingSummariesLiability: {
    GET_LIABILITIES_SUMMARY_DATA:
      '/v1/UnderwritingSummaryLiabilities/GetLiabilitiesSummaryData',
    UPSERT_LIABILITIES_SUMMARY_DATA:
      '/v1/UnderwritingSummaryLiabilities/UpsertLiability',
    DELETE_LIABILITIES_SUMMARY_DATA:
      '/v1/UnderwritingSummaryLiabilities/DeleteLiabilities',
  },

  classifyDocuments: {
    // V1
    GET_PDF: '/v1/ClassifyDocuments/GetDocumentPdf',
  },

  core: {
    BAIL_OUT_AND_SUBMIT_TO_SETUP: '/v1/Submission/BailOutAndSubmitLoanToSetup',
    GET_BOLT_STATUS: '/v1/BoltStatus/GetBoltStatus',
    GET_LOAN_SUMMARY: '/v1/Loan/GetLoanSummary',
  },

  finalReview: {
    GET_AUS_RECOMMENDATION: '/v1/AUS/GetAUSRecommendation',
  },
};

export default apiEndPoints;
